import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { OpeneconomicsLogo } from 'loghi';
import moment from 'moment';

function Footer() {
  return (
    <footer id='site-footer'>
      <Container>
        <Row>
          <Col className='text-center'>
            {window.location.pathname !== '/login' && (
              <a
                href='https://www.openeconomics.eu/'
                target='_blank'
                rel='noreferrer'
                alt='OpenEconomics'
                title='OpenEconomics'>
                <small>Powered by</small>
                <OpeneconomicsLogo
                  className='openeconomicslogo'
                  style={{ width: '15%', marginLeft: '0.7rem' }}
                />
              </a>
            )}
            <div className='copyright'>
              © {moment().format('Y')} Copyright OpenEconomics | Vat 12504821005
            </div>
            <Row className='footer-menu'>
              <Col>
                <span className='footer-menu-item no-to-head'>
                  <a
                    href='https://www.openeconomics.eu/privacy-policy'
                    target='_blank'
                    rel='noreferrer'>
                    Privacy policy
                  </a>
                </span>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}

export default Footer;
